module.exports = __webpack_public_path__ + "img/info-n.86f51ee7.svg";